import { Add, Audiotrack, CheckCircle, Delete, ExpandMore, ImageOutlined, SettingsOutlined, Videocam } from '@mui/icons-material';
import { Accordion, AccordionDetails, AccordionSummary, Button, FormControl, FormControlLabel, IconButton, InputLabel, Menu, MenuItem, Modal, Radio, RadioGroup, Select, Tab, Tabs, TextField, Tooltip, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import * as Sentry from "@sentry/react";
import React, { useCallback, useEffect, useId, useMemo, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';

import { Card, Col, Row } from 'antd';
import Acent from 'components/Acent';
import Loading from 'components/Loading';
import ModalMenu from 'components/Modals';
import AudioUploaderNonNativeAdmin from "components/NonNativeAdmin/audioUploaderNonNativeAdmin";
import ImageUploaderNonNativeAdmin from "components/NonNativeAdmin/imageUploaderNonNativeAdmin";
import VideoUploaderNonNativeAdmin from "components/NonNativeAdmin/videoUploaderNonNativeAdmin";
import TextEditor from 'components/TextEditor';
import { useAlertLoading } from "components/UI/alertSakeBar/alertProvider";
import SectionLabel from 'components/UI/label/SectionLabel';
import AudioRecorder from "features/AudeoRecorderNew";
import { cloneDeep, get, has, map, uniqueId } from "lodash";
import { handleCreatePlacementExam, handleUpdatePlacementExam } from 'store/placement_exam/thunks';
import { useCurrentUser } from 'store/users/selectors';
import { useRubrices } from 'store/rubric/selectors';
import { usePlacementExamDraft } from 'utils/methods/firebasePlacementExamDraft.ts';
import { handleAudioTranscript } from 'store/submissions/thunks';
import styled from 'styled-components';
import { DURATIONS } from 'utils/config/reference';
import COLOR from 'utils/constants/color';
import { disableBodyScroll } from 'utils/methods/math';
import { validateExamSections } from 'utils/methods/validateQuestionCreation';
import AudioPicker from "../AdminBooks/AudioPicker";
import PictureAssignment from 'components/Image/PictureAssignment';
import SentryWrap from 'components/Sentry';
import FullScreenLoader from 'components/UI/fullScreenLoader';

//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------

//  -- Components ---------------------



//  -- Constants ----------------------






















const LABEL = ['a', 'b', 'c', 'd', 'e']
const QUESTION_TYPE = [
    {
        type: 'Written Response',
        value: 'essay',
    },
    {
        type: 'Audio-Recording (also upload your own)',
        value: 'audio',
    },
    {
        type: 'Audio with multichoice',
        value: 'audio_multichoice',
    },
    {
        type: 'Audio with written response',
        value: 'audio_written_response',
    },
    {
        type: 'Multiple Choice',
        value: 'multipleChoice',
    },
    {
        type: 'True And False',
        value: 'trueFalse',
    }
]

const QUESTION_TYPES = {
    MULTIPLE_CHOICE: 'multipleChoice',
    ESSAY: 'essay',
    AUDIO: 'audio',
    AUDIO_MULTICHOICE: 'audio_multichoice',
    AUDIO_WRITTEN_RESPONSE: 'audio_written_response',
    TRUE_FALSE: 'trueFalse',
};

const DOMAIN_LEVELS = [
    { key: 'novice', label: 'Novice' },
    { key: 'early_intermediate', label: 'Early Intermediate' },
    { key: 'intermediate', label: 'Intermediate' },
    { key: 'advance', label: 'Advance' },
    { key: 'advance_high', label: 'Advance High' },
];

const CONFIG_DOMAIN_CATEGORIES = [
    { key: 'reading', label: 'Reading' },
    { key: 'writing', label: 'Writing' },
    { key: 'listening', label: 'Listening' },
    { key: 'speaking', label: 'Speaking' },
    { key: 'comprehension', label: 'Comprehension' },
    { key: 'literacy', label: 'Literacy' },
    { key: 'vocal', label: 'Vocal' },
    { key: 'active', label: 'Active' },
];

const getCategoryTooltip = (key) => {
    const map = {
        comprehension: 'Comprehension (Listening + Reading)',
        literacy: 'Literacy (Reading + Writing)',
        vocal: 'Vocal (Listening + Speaking)',
        active: 'Active (Speaking + Writing)',
    };
    return map[key] || null;
};

const COMBINED_CATEGORY_KEYS = {
    comprehension: ['listening', 'reading'],
    literacy: ['reading', 'writing'],
    vocal: ['listening', 'speaking'],
    active: ['speaking', 'writing'],
};

const getCategoryKeysForMaxPoints = (catKey) => COMBINED_CATEGORY_KEYS[catKey] || [catKey];

const getInitialDomainConfig = () => {
    const categoryObj = {};
    CONFIG_DOMAIN_CATEGORIES.forEach(cat => {
        categoryObj[cat.key] = {};
        DOMAIN_LEVELS.forEach(dom => {
            categoryObj[cat.key][dom.key] = { from: '', to: '' };
        });
    });
    return categoryObj;
};

const getInitialDomainConfigForCategory = () => {
    const obj = {};
    DOMAIN_LEVELS.forEach(dom => {
        obj[dom.key] = { from: '', to: '' };
    });
    return obj;
};
const Container = styled.div`
    width: 100%;
`;

const Description = styled.span`
    color: ${COLOR.black300};
    display: block;
    font-size: 13px;
    font-weight: 400;
    line-height: 18px;
    margin-bottom: 25px;
`;

const Header = styled(Description)`
    color: ${COLOR.black100};
    font-size: 28px;
    font-weight: 600;
    line-height: 28px;
    margin-bottom: 16px;
`;

const Note = styled.span`
    color: ${COLOR.black400};
    display: block;
    font-size: 13px;
    font-weight: 400;
    line-height: 20px;
    margin-bottom: 16px;
`;

const Wrapper = styled.div`
    margin: 0px auto;
    width: 100%;
    position: relative;
    top: 0px;
    min-height:90vh;
`;
const AssignmentDescription = styled.span`
    color: ${COLOR.black300};
    display: block;
    font-size: 12px;
    font-weight: 400;
    line-height: 17px;
`;


const RelativeContainer = styled.div`
    position: relative;
    width: 100%;
    padding: 16px;
    margin: 8px 0;
    border: 1px solid ${COLOR.black800};
    border-radius: 8px;
    background-color: #ffffff;
    box-shadow: 0 1px 3px rgba(0,0,0,0.08);
    transition: all 0.2s ease;
    &:hover {
        box-shadow: 0 2px 6px rgba(0,0,0,0.12);
        border-color: ${COLOR.green100};
    }
`;
const AssignmentTitle = styled.span`
    color: ${COLOR.black100};
    display: block;
    font-size: 16px;
    font-weight: 600;
    line-height: 18px;
`;
const Question = styled(AssignmentTitle)`
    font-size: 16px;
    line-height: 22px;
`;


const QuestionContainer = styled(Container)`
    margin-top: 0px;
    position: relative;
`;


const useStyles = makeStyles((theme) => ({
    root: {
        marginBottom: '25px',
        width: '300px'
    },
    rootDif: {
        width: '200px'
    },
    rootDifFull: {
        width: "100%"
    },
    sizeSmall: {
        width: '55px',
        height: '25px'
    },
    checkedSwitch: {
        transform: 'translateX(30px) !important'
    },
    label: {
        textTransform: 'uppercase',
    },
    formControl: {
        minWidth: 120
    },
    colorPrimary: {
        color: `${COLOR.green}!important`
    }
}));

const Content = styled.div`
    margin-top: 24px;
`;

const Detail = styled(AssignmentDescription)`
    color: ${COLOR.black600};
    display: inline-flex;
    align-items: center;
    font-size: 11px;
    font-weight: 600;
    text-transform: uppercase;
    margin-top:${p => p.index == 0 ? "0px" : "0px"};
    padding: 4px 12px;
    background-color: ${COLOR.green800};
    color: white;
    border-radius: 12px;
    letter-spacing: 0.5px;
`;

const InnerWrapper = styled.div`
        padding: 16px;
        width: 100%;
        min-width: 0;
        padding-bottom: 12px;
        border-right: 1px solid ${COLOR.black800};
        height: 85vh;
        max-height: 85vh;
        overflow: hidden;
        padding-right: 12px;
        margin-right: 8px;
        background-color: #fafafa;
        border-radius: 8px;
        box-shadow: 0 2px 4px rgba(0,0,0,0.05);
        display: flex;
        flex-direction: column;
}
`;
const InnerSectionScroll = styled.div`
        overflow-y: auto;
        overflow-x: hidden;
        scroll-behavior: smooth;
        min-height: 0;
        flex: 1;
        width: 100%;
        padding-right: 8px;
        ::-webkit-scrollbar {
            width: 6px;
            height: 6px;
          }
        ::-webkit-scrollbar-thumb {
            background-color: ${COLOR.black600};
            border-radius: 3px;
          }
`;
const InnerQuestionWrapper = styled.div`
        padding: 8px;
        width: 100%;
        min-width: 0;
        min-height: 0;
        overflow-y: auto;
        overflow-x: hidden;
        scroll-behavior: smooth;
        padding-bottom: 12px;
        height: 100%;
        max-height: 100%;
        padding-right: 8px;
        background-color: #ffffff;
        border-radius: 6px;
        margin-top: 0;
        ::-webkit-scrollbar {
            width: 6px;
            height: 6px;
          }
        ::-webkit-scrollbar-thumb {
            background-color: ${COLOR.black600};
            border-radius: 3px;
          }
}
`;
const SectionWrapper = styled.div`
        padding: 0px;
        width: 100%;
        overflow-y: auto;
        overflow-x: auto;
        scroll-behavior: smooth;
        max-height: 82vh;
        overflow: hidden;
        display: flex;
        flex-direction: row;
        row-gap: 12px;
        padding-bottom: 12px;
        padding-right: 8px;
        margin-top: 16px;
        gap: 12px;
        ::-webkit-scrollbar {
            width: 8px;
            height: 8px;
          }
        ::-webkit-scrollbar-thumb {
            background-color: ${COLOR.black600};
            border-radius: 4px;
          }
        ::-webkit-scrollbar-track {
            background-color: #f1f1f1;
            border-radius: 4px;
          }
}
`;
const RadioColumn = styled(Col)`
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: 22px;
`

const ModalContent = styled.div`
    align-items: center;
    background-color: ${COLOR.white};
    border-radius: 8px;
    display: inline-flex;
    flex-direction: column;
    left: 50%;
    max-width: 400px;
    padding: 24px;
    position: absolute;
    text-align: center;
    top: 50%;
    transform: translate(-50%, -50%);
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
`;

const ModalTitle = styled.h3`
    margin: 0 0 12px 0;
    color: ${COLOR.black100};
    font-size: 18px;
    font-weight: 600;
`;

const ModalText = styled.p`
    margin: 0 0 20px 0;
    color: ${COLOR.black300};
    font-size: 14px;
    line-height: 1.5;
`;

const ModalButtonRow = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    gap: 12px;
    width: 100%;
`;

const EmptyStatePlaceholder = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 60px 40px;
    margin-top: 40px;
    background-color: #fafafa;
    border: 2px dashed ${COLOR.black700};
    border-radius: 12px;
    text-align: center;
`;

const EmptyStateTitle = styled.h3`
    margin: 0 0 12px 0;
    color: ${COLOR.black300};
    font-size: 20px;
    font-weight: 600;
`;

const EmptyStateText = styled.p`
    margin: 0 0 24px 0;
    color: ${COLOR.black500};
    font-size: 14px;
    line-height: 1.5;
    max-width: 400px;
`;

const FilteredEmptyState = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 40px 20px;
    width: 100%;
    background-color: #fafafa;
    border: 1px dashed ${COLOR.black700};
    border-radius: 8px;
    text-align: center;
    color: ${COLOR.black400};
    font-size: 15px;
    font-weight: 500;
`;

const ConfigDomainCard = styled(Card)`
    max-width: 680px;
    width: 100%;
    max-height: 90vh;
    display: flex;
    flex-direction: column;
    margin: 0;
    border-radius: 12px;
    box-shadow: 0 8px 32px rgba(0,0,0,0.12);
    overflow: auto;

    &.ant-card .ant-card-body,
    .ant-card .ant-card-body {
        padding: 10px !important;
    }
    @media (max-width: 768px) {
        max-width: 95vw;
    }
    @media (max-width: 600px) {
        max-width: 100%;
        max-height: 85vh;
        border-radius: 8px;
    }
`;

const ConfigDomainHeader = styled.div`
    padding: 10px !important;
    flex-shrink: 0;
    @media (max-width: 768px) {
        padding: 16px 20px 0;
    }
    @media (max-width: 600px) {
        padding: 14px 16px 0;
    }
`;

const ConfigDomainTablist = styled.div`
    display: flex;
    width: 100%;
    border-bottom: 1px solid rgba(0,0,0,0.08);
    overflow-x: auto;
    overflow-y: hidden;
    scrollbar-width: thin;
    -webkit-overflow-scrolling: touch;
    @media (max-width: 600px) {
        margin: 0 -16px;
        padding: 0 16px;
    }
`;

const ConfigDomainTabBtn = styled.button`
    flex: 0 0 auto;
    min-width: 72px;
    padding: 12px 14px;
    border: none;
    background: ${p => {
        if(p.$hasMissing) return 'rgba(211, 47, 47, 0.08)';
        if (!p.$active) return 'transparent';
        return 'rgba(25, 118, 210, 0.06)';
    }};
    cursor: pointer;
    font-size: 13px;
    font-weight: ${p => p.$active ? 600 : 500};
    color: ${p => {
        if (!p.$active) return 'rgba(0,0,0,0.6)';
        return p.$hasMissing ? '#d32f2f' : '#1976d2';
    }};
    border-bottom: 2px solid ${p => {
        if (!p.$active) return 'transparent';
        return p.$hasMissing ? '#d32f2f' : '#1976d2';
    }};
    margin-bottom: -1px;
    position: relative;
    z-index: ${p => p.$active ? 1 : 0};
    transition: color 0.15s ease, background 0.15s ease;
    white-space: nowrap;
    @media (max-width: 600px) {
        min-width: 56px;
        padding: 10px 8px;
        font-size: 12px;
    }
`;

const ConfigDomainBody = styled.div`
    padding: 10px !important;
    overflow-y: auto;
    overflow-x: visible;
    flex: 1;
    min-height: 0;
    @media (max-width: 768px) {
        padding: 16px 20px 20px;
    }
    @media (max-width: 600px) {
        padding: 14px 16px 20px;
    }
`;

const ConfigDomainRow = styled.div`
    display: grid;
    grid-template-columns: 1fr 120px 120px;
    gap: 12px;
    align-items: center;
    padding: 12px 14px;
    background: rgba(0,0,0,0.02);
    border-radius: 8px;
    border: 1px solid rgba(0,0,0,0.06);
    @media (max-width: 600px) {
        grid-template-columns: 1fr 1fr;
        gap: 10px;
        padding: 10px 12px;
    }
`;

const ConfigDomainRowLabel = styled(Typography)`
    font-weight: 500;
    @media (max-width: 600px) {
        grid-column: 1 / -1;
        font-size: 13px !important;
    }
`;

const ConfigDomainActions = styled.div`
    margin-top: 24px;
    padding-top: 20px;
    border-top: 1px solid rgba(0,0,0,0.08);
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    @media (max-width: 768px) {
        margin-top: 20px;
        padding-top: 16px;
    }
    @media (max-width: 600px) {
        flex-direction: column;
        margin-top: 18px;
        padding-top: 14px;
        gap: 8px;
        & > button {
            width: 100%;
        }
    }
`;

const INIT_QUESTIONS = [{
    section_title: 'Section 1',
    questions: [{
        "options": [
            "",
            "",
            "",
            ""
        ],
        "id": 1,
        "question": "",
        "type": "multipleChoice",
        "answer": 0,
    }]
}]
const AddAudioTOsection = ({ audio_url, onChange }) => {
    const [openAudioModal, setAudeioModal] = useState(false)
    const handleClose = () => {
        setAudeioModal(false)
    }
    return (<>
        <Button
            className='adoVdoAddBtn'
            size="small"
            variant="contained"
            color="primary"
            style={{ 
                height: 36,
                fontWeight: 500,
                textTransform: 'none',
                borderRadius: 6
            }}
            onClick={() => setAudeioModal(true)}
            startIcon={audio_url && <CheckCircle />}
        >
            <Audiotrack />  Audio
        </Button>
        <AudioUploaderNonNativeAdmin audioUrl={audio_url} openAudioModal={openAudioModal} handleClose={handleClose} getUrl={(v) => { onChange(v) }} has_delete />
    </>)
}
const AddvideoToSections = ({ video_url, onChange }) => {
    const [openVideoModal, setVideoModal] = useState(false)
    const handleClose = () => {
        setVideoModal(false)
    }
    return (<>
        <Button
            className='adoVdoAddBtn'
            size="small"
            variant="contained"
            color="primary"
            style={{ 
                height: 36,
                fontWeight: 500,
                textTransform: 'none',
                borderRadius: 6
            }}
            onClick={() => setVideoModal(true)}
            startIcon={video_url && <CheckCircle />}
        >
            <Videocam />  Video
        </Button>
        <VideoUploaderNonNativeAdmin videoUrl={video_url} openVideoModal={openVideoModal} handleClose={handleClose}  getUrl={(v) => { onChange(v) }} has_delete />
    </>)
}
const AddImageToSections = ({ image_url, onChange }) => {
    const [openImageModal, setImageModal] = useState(false)
    const handleClose = () => {
        setImageModal(false)
    }
    return (<>
        <Button
            className='adoVdoAddBtn'
            size="small"
            variant="contained" 
            color="primary"
            style={{
                height: 36,
                fontWeight: 500,
                textTransform: 'none',
                borderRadius: 6
            }}
            onClick={() => setImageModal(true)}
            startIcon={image_url && <CheckCircle />}
        >
            <ImageOutlined />  Image
        </Button>
        <ImageUploaderNonNativeAdmin imageUrl={image_url} openImageModal={openImageModal} handleClose={handleClose} getUrl={(v) => { onChange(v) }} has_delete />
    </>)
}

const PlacementExamForm = ({
    data,
    onCreateOrUpdate,
}) => {
    const {setAlertLoading, showAlert} = useAlertLoading();
    const classes = useStyles();
    const [questions, setQuestions] = useState(INIT_QUESTIONS)
    const [displayName, setdisplayName] = useState('')
    const [duration, setduration] = useState(0)
    const [loading, setLoading] = useState(false)
    const [errors, setError] = useState([])
    const [categoryMenuAnchor, setCategoryMenuAnchor] = useState(null)
    const [selectedTab, setSelectedTab] = useState('all')
    const [sectionSelectedTab, setSectionSelectedTab] = useState(0)
    const [deleteSectionModal, setDeleteSectionModal] = useState({ open: false, sectionIndex: null })
    const [questionAccordionCollapsed, setQuestionAccordionCollapsed] = useState(() => new Set())
    const dispatch = useDispatch()

    const toggleQuestionAccordion = (sectionIndex, qIndex) => {
        setQuestionAccordionCollapsed(prev => {
            const next = new Set(prev)
            const key = `${sectionIndex}-${qIndex}`
            if (next.has(key)) next.delete(key)
            else next.add(key)
            return next
        })
    }
    const isEditing = !data?.isDraft && has(data, "id")
    const innerRef = useRef([])
    const dispNameRef = useRef();
    const questionRefs = useRef([]);
    const optionRefs = useRef([]);
    const all_rubrics = useRubrices();
    const [configDomainModal, setConfigDomainModal] = useState({ open: false, domain: null });
    const [domainConfig, setDomainConfig] = useState(getInitialDomainConfig());
    const { savePlacementExamDraft, fetchPlacementExamDraft, deletePlacementExamDraft } = usePlacementExamDraft();
    const id = useId();
    const draftDocId = data?.docId || (data?.id ? String(data.id) : `new_${id}`);
    const draftSaveTimeoutRef = useRef(null);
    const skipDraftSaveRef = useRef(true);
    const [fullScreenLoader, setFullScreenLoader] = useState(false);

    const sectionWiseData = useMemo(() => {
        return questions
            .map((section, originalIndex) => ({ ...section, _originalIndex: originalIndex }))
            .filter((section) => {
                if (selectedTab === 'all') return true;
                return section.category_type === selectedTab;
            });
    }, [selectedTab, questions]);

    useEffect(() => {
        setSectionSelectedTab(prev => {
            const stillExists = sectionWiseData.some(s => s._originalIndex === prev);
            return stillExists ? prev : (sectionWiseData[0]?._originalIndex ?? prev);
        });
    }, [selectedTab])

    useEffect(() => {
        if (skipDraftSaveRef.current) {
            skipDraftSaveRef.current = false;
            return;
        }
        if (draftSaveTimeoutRef.current) clearTimeout(draftSaveTimeoutRef.current);
        draftSaveTimeoutRef.current = setTimeout(() => {
            savePlacementExamDraft(draftDocId, {
                questions: cloneDeep(questions),
                displayName,
                duration,
                domainConfig,
                is_created: data?.isDraft ? true : (data && data.id ? false : true)
            });
            draftSaveTimeoutRef.current = null;
        }, 800);
        return () => {
            if (draftSaveTimeoutRef.current) clearTimeout(draftSaveTimeoutRef.current);
        };
    }, [questions, displayName, duration, domainConfig, draftDocId]);

    const loadDraft = useCallback(async () => {
        try {
            setFullScreenLoader(true);
            const draft = await fetchPlacementExamDraft(draftDocId);
            if (!draft) {
                //showAlert('No draft saved.', 'info');
                if (typeof data === "object" && Object.keys(data).length) {
                    skipDraftSaveRef.current = true;
                    setQuestions(data.questions)
                    setdisplayName(data.displayName)
                    setduration(data.duration)
                    if (data.domainConfig && typeof data.domainConfig === 'object') {
                        const base = getInitialDomainConfig();
                        CONFIG_DOMAIN_CATEGORIES.forEach(cat => {
                            if (data.domainConfig[cat.key]) {
                                DOMAIN_LEVELS.forEach(dom => {
                                    if (data.domainConfig[cat.key][dom.key]) {
                                        base[cat.key][dom.key] = {
                                            from: data.domainConfig[cat.key][dom.key].from ?? '',
                                            to: data.domainConfig[cat.key][dom.key].to ?? '',
                                        };
                                    }
                                });
                            }
                        });
                        setDomainConfig(base);
                    }
                }
                return;
            }
            if (draft.questions && Array.isArray(draft.questions) && draft.questions.length > 0) {
                setQuestions(draft.questions);
            }
            if (draft.displayName != null) setdisplayName(draft.displayName);
            if (draft.duration != null) setduration(draft.duration);
            if (draft.domainConfig && typeof draft.domainConfig === 'object') {
                const base = getInitialDomainConfig();
                CONFIG_DOMAIN_CATEGORIES.forEach(cat => {
                    if (draft.domainConfig[cat.key]) {
                        DOMAIN_LEVELS.forEach(dom => {
                            if (draft.domainConfig[cat.key][dom.key]) {
                                base[cat.key][dom.key] = {
                                    from: draft.domainConfig[cat.key][dom.key].from ?? '',
                                    to: draft.domainConfig[cat.key][dom.key].to ?? '',
                                };
                            }
                        });
                    }
                });
                setDomainConfig(base);
            }
            setError([]);
            showAlert('Draft restored.', 'success');
        } catch (e) {
            showAlert('Failed to load draft.', 'error');
            Sentry.captureException(e);
        }
        finally {
            setFullScreenLoader(false);
        }
    }, [draftDocId]);

    useEffect(() => {
        loadDraft();
        // if (data?.isDraft) return;
        // if (typeof data === "object" && Object.keys(data).length) {
        //     skipDraftSaveRef.current = true;
        //     setQuestions(data.questions)
        //     setdisplayName(data.displayName)
        //     setduration(data.duration)
        //     if (data.domainConfig && typeof data.domainConfig === 'object') {
        //         const base = getInitialDomainConfig();
        //         CONFIG_DOMAIN_CATEGORIES.forEach(cat => {
        //             if (data.domainConfig[cat.key]) {
        //                 DOMAIN_LEVELS.forEach(dom => {
        //                     if (data.domainConfig[cat.key][dom.key]) {
        //                         base[cat.key][dom.key] = {
        //                             from: data.domainConfig[cat.key][dom.key].from ?? '',
        //                             to: data.domainConfig[cat.key][dom.key].to ?? '',
        //                         };
        //                     }
        //                 });
        //             }
        //         });
        //         setDomainConfig(base);
        //     }
        // }
    }, [data]);

    useEffect(() => {
        if (!data?.isDraft || !data?.docId) return;
        let cancelled = false;
        fetchPlacementExamDraft(data.docId).then((draft) => {
            if (cancelled || !draft) return;
            skipDraftSaveRef.current = true;
            setQuestions(Array.isArray(draft.questions) && draft.questions.length > 0 ? draft.questions : INIT_QUESTIONS);
            setdisplayName(draft.displayName != null ? draft.displayName : '');
            setduration(draft.duration != null ? draft.duration : 0);
            if (draft.domainConfig && typeof draft.domainConfig === 'object') {
                const base = getInitialDomainConfig();
                CONFIG_DOMAIN_CATEGORIES.forEach(cat => {
                    if (draft.domainConfig[cat.key]) {
                        DOMAIN_LEVELS.forEach(dom => {
                            if (draft.domainConfig[cat.key][dom.key]) {
                                base[cat.key][dom.key] = {
                                    from: draft.domainConfig[cat.key][dom.key].from ?? '',
                                    to: draft.domainConfig[cat.key][dom.key].to ?? '',
                                };
                            }
                        });
                    }
                });
                setDomainConfig(base);
            }
        });
        return () => { cancelled = true; };
    }, [data?.isDraft, data?.docId]);

    const trenacriptAudio = (url) => {
        handleAudioTranscript(url)
    }
    const onSubmit = async (e) => {
        try {
            const updatedQuestions = cloneDeep(questions);
            const maxPointErrors = [];
            const usedSkillTypes = [...new Set(updatedQuestions.map(s => s.category_type).filter(Boolean))];
            const categoriesToValidate = new Set(usedSkillTypes);
            Object.keys(COMBINED_CATEGORY_KEYS).forEach(combinedKey => {
                const skillsInCombined = COMBINED_CATEGORY_KEYS[combinedKey];
                if (skillsInCombined.some(skill => usedSkillTypes.includes(skill))) {
                    categoriesToValidate.add(combinedKey);
                }
            });
            const missingDomainFields = [];
            categoriesToValidate.forEach(catKey => {
                const cat = CONFIG_DOMAIN_CATEGORIES.find(c => c.key === catKey);
                if (!cat) return;
                DOMAIN_LEVELS.forEach(dom => {
                    const val = domainConfig[cat.key]?.[dom.key];
                    const fromValue = String(val?.from ?? '').trim();
                    const toValue = String(val?.to ?? '').trim();
                    if (fromValue === '') {
                        missingDomainFields.push(`Configuration Domain: ${cat.label} - ${dom.label}: From is required`);
                    }
                    if (toValue === '') {
                        missingDomainFields.push(`Configuration Domain: ${cat.label} - ${dom.label}: To is required`);
                    }
                });
            });
            const advanceHighMismatch = [];
            categoriesToValidate.forEach(catKey => {
                const cat = CONFIG_DOMAIN_CATEGORIES.find(c => c.key === catKey);
                if (!cat) return;
                const categoryMaxPoint = updatedQuestions
                    .filter(s => getCategoryKeysForMaxPoints(cat.key).includes((s.category_type || '').toLowerCase()))
                    .reduce((sum, s) => sum + (parseFloat(s.max_point) || 0), 0);
                if (categoryMaxPoint > 0) {
                    const advanceHighTo = Number.parseFloat(String(domainConfig?.[cat.key]?.advance_high?.to ?? '').trim());
                    if (Number.isNaN(advanceHighTo) || Math.abs(advanceHighTo - categoryMaxPoint) > 0.01) {
                        advanceHighMismatch.push(`Configuration Domain: ${cat.label} - Advance High To must be ${categoryMaxPoint}`);
                    }
                }
            });
            if (missingDomainFields.length > 0) {
                showAlert("Please check Configuration Domain fields for required skill types", 'warning');
               // setError(missingDomainFields);
                return;
            }
            if (advanceHighMismatch.length > 0) {
                showAlert("Please check Configuration Domain fields for required skill types", 'warning');
               // setError(advanceHighMismatch);
                return;
            }

            updatedQuestions.forEach((section, section_index) => {
                if(!section.rubric_id || section.rubric_id === null && section.rubric_id === undefined && section.rubric_id === '') {
                    if (section.questions) {
                        section.questions.forEach((question, q_index) => {
                            if (!question.max_point || question.max_point === null || question.max_point === undefined || question.max_point === '' || isNaN(parseFloat(question.max_point))) {
                                maxPointErrors.push(`Section ${section_index + 1}, Question ${q_index + 1}: Max Points is required`);
                            }
                        });
                        const totalMaxPoint = section.questions.reduce((sum, q) => {
                            const maxPoint = parseFloat(q.max_point) || 0;
                            return sum + maxPoint;
                        }, 0);
                        updatedQuestions[section_index].max_point = totalMaxPoint;
                    }
                }
            });
            
            if (maxPointErrors.length > 0) {
                showAlert(maxPointErrors[0], "error");
                setError(maxPointErrors);
                return;
            }
            
            setQuestions(updatedQuestions);
            
            const validations = validateExamSections(updatedQuestions)
            if (validations.length > 0) {
                showAlert(`All fields are required`, "error")
                setError(validations)
                return
            }
            setLoading(true);
            setAlertLoading(true,'Updating ...', "info")
            if (data && data.id && !data.isDraft) {
                const update_data = await dispatch(handleUpdatePlacementExam({
                    ...data,
                    displayName,
                    questions: updatedQuestions,
                    duration,
                    domainConfig,
                }))
                if (update_data && update_data.success) {
                    if (draftDocId) {
                        try {
                            await deletePlacementExamDraft(draftDocId);
                        } catch (e) {
                            Sentry.captureException(e);
                        }
                    }
                    setAlertLoading(false,'');
                    showAlert(`create successfully`, "success")
                    if (onCreateOrUpdate) {
                        onCreateOrUpdate()
                    }
                } else {
                    setAlertLoading(false,'');
                    showAlert(update_data && update_data.message ? update_data.message : `Something went wrong`, "error")
                }
            } else {
                const create_data = await dispatch(handleCreatePlacementExam({
                    displayName,
                    questions: updatedQuestions,
                    duration,
                    domainConfig,
                }))
                if (create_data && create_data.success) {
                    if (data?.isDraft && data?.docId) {
                        try {
                            await deletePlacementExamDraft(data.docId)
                        } catch (e) {
                            Sentry.captureException(e)
                        }
                    }else  if(draftDocId){
                        try {
                            await deletePlacementExamDraft(draftDocId)
                        } catch (e) {
                            Sentry.captureException(e)
                        }
                    }
                    showAlert(`create successfully`, "success")
                    if (onCreateOrUpdate) {
                        onCreateOrUpdate()
                    }
                } else {
                    showAlert(create_data && create_data.message ? create_data.message : `Something went wrong`, "error")
                }

            }

        } catch (error) {
            Sentry.captureException(`385 Error during onSubmit: ${error}`);
            console.log(error);
        } finally {
            setLoading(false);
            setAlertLoading(false,'');
        }

    };


    useEffect(() => {
        if (data) {

        }
    }, [data])
    const onChangeQuestionData = (val, key, i, section_index) => {
        const v = cloneDeep(questions)
        if (v[section_index]) {
            const que = v[section_index].questions
            que[i][key] = val;
            v[section_index].questions = que;
            setQuestions(v)
            setError([])
            if (key === "max_point") {
                setTimeout(() => {
                    calculateAndUpdateSectionMaxPoint(section_index);
                }, 0);
            }
        }
    }

    const onChangeQuestionType = (type, i, section_index) => {
        const value = cloneDeep(questions)
        if (value[section_index]) {
            const v = value[section_index].questions
            v[i].type = type;
            switch (type) {
                case QUESTION_TYPES.MULTIPLE_CHOICE:
                    v[i].options = Array.isArray(v[i].options) &&
                        v[i].options.length === 4 &&
                        typeof v[i].options[0] !== "object"
                        ? v[i].options
                        : ['', '', '', ''];
                    v[i].answer = !isNaN(parseInt(v[i].answer)) ? v[i].answer : 0;
                    break;

                case QUESTION_TYPES.TRUE_FALSE:
                    v[i].options = ['Cierto', 'Falso'];
                    v[i].answer = !isNaN(parseInt(v[i].answer)) ? v[i].answer : 0;
                    break;
                case QUESTION_TYPES.ESSAY:
                    delete v[i].options;
                    delete v[i].answer;
                    delete v[i].audio;
                    break;
                case QUESTION_TYPES.AUDIO:
                    v[i].duration = 60;
                    delete v[i].options;
                    delete v[i].answer;
                    break;
                case QUESTION_TYPES.AUDIO_WRITTEN_RESPONSE:
                    delete v[i].question;
                    delete v[i].options;
                    delete v[i].answer;
                    break;
                case QUESTION_TYPES.AUDIO_MULTICHOICE:
                    delete v[i].question;
                    v[i].options = Array.isArray(v[i].options) &&
                        v[i].options.length === 4 &&
                        typeof v[i].options[0] !== "object"
                        ? v[i].options
                        : ['', '', '', ''];
                    v[i].answer = !isNaN(parseInt(v[i].answer)) ? v[i].answer : 0;
                    break;
                default:
                    break;
            }
            value[section_index].questions = v;
            setQuestions(value)
            setError([])
        }
    }
    const onchangeOption = (index, optIndex, value, section_index) => {

        const v = cloneDeep(questions)
        if (v[section_index]) {
            const updatedQuestions = v[section_index].questions;
            if (!updatedQuestions[index].options) {
                updatedQuestions[index].options = [];
            }
            while (updatedQuestions[index].options.length <= optIndex) {
                updatedQuestions[index].options.push('');
            }
            updatedQuestions[index].options[optIndex] = value;
            v[section_index].questions = updatedQuestions;
            setQuestions(v)
            setError([])
        }
    };



    const onChangeOptionsLength = (index, length, section_index) => {
        const value = cloneDeep(questions)
        if (value[section_index]) {
            const updatedQuestions = value[section_index].questions;
            if (updatedQuestions[index].options) {
                let opt = updatedQuestions[index].options.slice(0, length)
                if (opt.length == length) {
                    updatedQuestions[index].options = opt;
                    if (updatedQuestions[index].answer >= opt.length) {
                        updatedQuestions[index].answer = 0;
                    }
                } else {
                    let len = length - opt.length;
                    let arr = new Array(len).fill('', 0, len)
                    opt.push(...arr)
                    updatedQuestions[index].options = opt;
                }
            } else {
                updatedQuestions[index].options = new Array(length).fill('')
                updatedQuestions[index].answer = 0;
            }
            value[section_index].questions = updatedQuestions;
            setQuestions(value)
            setError([])
        }
    }
    const onDeleteQuestion = (section_index, index) => {
        const v = cloneDeep(questions)
        if (v[section_index]) {
            if (v[section_index].questions.length <= 1) {
                showAlert(`Each section must contain at least one question, or you have the option to delete the entire section.`, "error")
                return;
            }
            v[section_index].questions.splice(index, 1)
            setQuestions(v)
            setError([])
            setTimeout(() => {
                calculateAndUpdateSectionMaxPoint(section_index);
            }, 0);
        }

    }
    const onDeleteSection = (section_index) => {
        if (questions.length <= 1) {
            showAlert(`At least one section is required in the activity.`, "error")
            return;
        }
        setDeleteSectionModal({ open: true, sectionIndex: section_index })
    }

    const confirmDeleteSection = () => {
        const section_index = deleteSectionModal.sectionIndex
        const v = cloneDeep(questions)
        if (Array.isArray(v) && section_index !== null) {
            v.splice(section_index, 1)
            setQuestions(v)
            setError([])
        }
        setDeleteSectionModal({ open: false, sectionIndex: null })
    }

    const cancelDeleteSection = () => {
        setDeleteSectionModal({ open: false, sectionIndex: null })
    }
    const onAddQuestion = (section_index) => {
        const v = cloneDeep(questions)
        if (v[section_index]) {
            const q = v[section_index];
            const section_question = q.questions || [];
            let _id = parseInt(get(section_question[section_question.length - 1], "id", 0))
            _id = isNaN(_id) ? 0 : _id + 1
            section_question.push({
                "id": _id,
                "question": "",
                "type": "essay",
            })
            q.questions = section_question;
            v[section_index] = q;
            setQuestions(v)
            setTimeout(() => {
                calculateAndUpdateSectionMaxPoint(section_index);
            }, 0);
            if (innerRef.current && innerRef.current[section_index]) {
                setTimeout(() => {
                    innerRef.current[section_index].scrollTo(0, innerRef.current[section_index].scrollHeight)
                }, 500)
            }

        }
    }


    useEffect(() => {
        document.documentElement.style.overflow = "hidden";
        disableBodyScroll('PlacementExamForm');

        return () => {
            document.documentElement.style.overflow = "auto";
            document.body.style.overflow = "auto";
        };
    }, []);
    function scrollHorizontallyToEnd() {
        if (innerRef.current && innerRef.current['section_container']) {
            innerRef.current['section_container'].scrollTo({
                left: innerRef.current['section_container'].scrollWidth + 450,
                behavior: 'smooth', // Optional: adds smooth scrolling
            });
        }
    }
    const onAddSections = (event) => {
        setCategoryMenuAnchor(event.currentTarget)
    };

    const handleCategorySelect = (categoryType) => {
        const newSectionIndex = questions.length;
        const newSectionTitle = `Section ${newSectionIndex + 1}`;
        setQuestions([...questions, {
            section_title: newSectionTitle,
            category_type: categoryType,
            questions: [{
                "options": [
                    "",
                    "",
                    "",
                    ""
                ],
                "id": 1,
                "question": "",
                "type": "multipleChoice",
                "answer": 0,
            }]
        }])
        setSelectedTab(categoryType)
        setSectionSelectedTab(newSectionIndex)
        setCategoryMenuAnchor(null)
        setTimeout(() => {
            scrollHorizontallyToEnd()
        }, 500)
    };

    const handleCategoryMenuClose = () => {
        setCategoryMenuAnchor(null)
    };
    const editSectionTitle = (text, section_index) => {
        setQuestions(prevQuestions => {
            const updatedQuestions = cloneDeep(prevQuestions);
    
            if (updatedQuestions[section_index]) {
                updatedQuestions[section_index].section_title = text;
            }
            return updatedQuestions;
        });
        setError([]); // Clear errors
    };
    const addSectionData = (key, data , section_index) => {
        setQuestions(prevQuestions => {
            const updatedQuestions = cloneDeep(prevQuestions);
    
            if (updatedQuestions[section_index]) {
                updatedQuestions[section_index][key] = data;
            }
    
            return updatedQuestions;
        });
    
        setError([]); // Clear errors
    };
    const editRubricsForSection = (rubric, section_index) => {
        try{
            setQuestions(prevQuestions => {
                const updatedQuestions = cloneDeep(prevQuestions);
                if (updatedQuestions[section_index]) {
                    if (rubric && typeof rubric === "object" && rubric.id) {
                        const section = updatedQuestions[section_index];
                        const rubricMaxPoint = parseFloat(rubric.max_point) || 0;
                        section.rubric_id = rubric.id;
                        section.max_point = rubricMaxPoint;
                        const questionCount = section.questions?.length || 0;
                        if (questionCount > 0) {
                            const basePoint = Number((rubricMaxPoint / questionCount).toFixed(2));
                            let assignedTotal = 0;
                            section.questions = section.questions.map((question, qIndex) => {
                                const point = qIndex === questionCount - 1
                                    ? Number((rubricMaxPoint - assignedTotal).toFixed(2))
                                    : basePoint;
                                assignedTotal += point;
                                return { ...question, max_point: point };
                            });
                        }
                    } else {
                        delete updatedQuestions[section_index].rubric_id;
                        if (updatedQuestions[section_index].questions?.length) {
                            const totalMaxPoint = updatedQuestions[section_index].questions.reduce((sum, q) => {
                                const maxPoint = parseFloat(q.max_point) || 0;
                                return sum + maxPoint;
                            }, 0);
                            updatedQuestions[section_index].max_point = totalMaxPoint;
                        } else {
                            delete updatedQuestions[section_index].max_point;
                        }
                    }
                }
                return updatedQuestions;
            });
            const categoryType = questions[section_index]?.category_type;
            if (categoryType) {
                setDomainConfig(prev => ({ ...prev, [categoryType]: getInitialDomainConfigForCategory() }));
            }
            setError([]);
        }catch(error){
            console.log(error, "error in editRubricsForSection");
            Sentry.captureException(`385 Error during editRubricsForSection: ${error}`);
        }
    };
    const editMaxPointForSection = (max_point, section_index) => {
        setQuestions(prevQuestions => {
            const updatedQuestions = cloneDeep(prevQuestions);
    
            if (updatedQuestions[section_index]) {
                updatedQuestions[section_index].max_point = max_point;
            }
    
            return updatedQuestions;
        });
        setError([])
    }
    const createRangeBasedonMaxPoint = (max_point, category_type) => {
        const total = parseFloat(max_point);
        if (!total || total <= 0 || !category_type) return;
    
        const n = DOMAIN_LEVELS.length;
        const step = total / n;
        const ranges = {};
    
        let currentFrom = 0;
    
        DOMAIN_LEVELS.forEach((dom, index) => {
            let to;
    
            if (index === n - 1) {
                to = total;
            } else {
                to = parseFloat((currentFrom + step).toFixed(1));
            }
    
            ranges[dom.key] = {
                from: currentFrom.toFixed(1),
                to: to.toFixed(1),
            };
    
            currentFrom = parseFloat((to + 0.1).toFixed(1));
        });
    
        setDomainConfig(prev => ({
            ...prev,
            [category_type]: {
                ...prev[category_type],
                ...ranges
            }
        }));
    };

    const calculateAndUpdateSectionMaxPoint = (section_index) => {
        setQuestions(prevQuestions => {
            const updatedQuestions = cloneDeep(prevQuestions);
            if (updatedQuestions[section_index] && updatedQuestions[section_index].questions) {
                if (updatedQuestions[section_index].rubric_id) {
                    const rubricMaxPoint = parseFloat(updatedQuestions[section_index].max_point) || 0;
                    const questionCount = updatedQuestions[section_index].questions.length || 0;
                    if (questionCount > 0) {
                        const basePoint = Number((rubricMaxPoint / questionCount).toFixed(2));
                        let assignedTotal = 0;
                        updatedQuestions[section_index].questions = updatedQuestions[section_index].questions.map((question, qIndex) => {
                            const point = qIndex === questionCount - 1
                                ? Number((rubricMaxPoint - assignedTotal).toFixed(2))
                                : basePoint;
                            assignedTotal += point;
                            return { ...question, max_point: point };
                        });
                    }
                } else {
                    const totalMaxPoint = updatedQuestions[section_index].questions.reduce((sum, q) => {
                        const maxPoint = parseFloat(q.max_point) || 0;
                        return sum + maxPoint;
                    }, 0);
                    updatedQuestions[section_index].max_point = totalMaxPoint;
                }
            }
            return updatedQuestions;
        });
    }
    // const editSectionInstruction = (text, section_index) => {
    //     const v = cloneDeep(questions)
    //     if (v[section_index]) {
    //         v[section_index].section_instruction = text;
    //     }
    //     setQuestions(v)
    // }
    const getRubricData = (id) => {
        if (typeof id === 'string' && id) {
            return all_rubrics?.find(k => k.id === id) || {}
        }
        return {}
    }

    const resetToOriginalData = useCallback(() => {
        skipDraftSaveRef.current = true
        if (typeof data === "object" && data && Object.keys(data).length > 0) {
            setQuestions(Array.isArray(data.questions) && data.questions.length > 0 ? cloneDeep(data.questions) : INIT_QUESTIONS)
            setdisplayName(data.displayName || '')
            setduration(data.duration || 0)
            if (data.domainConfig && typeof data.domainConfig === 'object') {
                const base = getInitialDomainConfig()
                CONFIG_DOMAIN_CATEGORIES.forEach(cat => {
                    if (data.domainConfig[cat.key]) {
                        DOMAIN_LEVELS.forEach(dom => {
                            if (data.domainConfig[cat.key][dom.key]) {
                                base[cat.key][dom.key] = {
                                    from: data.domainConfig[cat.key][dom.key].from ?? '',
                                    to: data.domainConfig[cat.key][dom.key].to ?? '',
                                }
                            }
                        })
                    }
                })
                setDomainConfig(base)
            } else {
                setDomainConfig(getInitialDomainConfig())
            }
            setError([])
            showAlert('Reset to original data.', 'success')
        } else {
            setQuestions(INIT_QUESTIONS)
            setdisplayName('')
            setduration(0)
            setDomainConfig(getInitialDomainConfig())
            setError([])
            showAlert('Reset to default.', 'info')
        }
    }, [data, showAlert])

    return (
        <SentryWrap>
            <FullScreenLoader isLoading={fullScreenLoader}  />
            <Menu
                anchorEl={categoryMenuAnchor}
                open={Boolean(categoryMenuAnchor)}
                onClose={handleCategoryMenuClose}
            >
                <MenuItem onClick={() => handleCategorySelect('reading')}>Reading</MenuItem>
                <MenuItem onClick={() => handleCategorySelect('speaking')}>Speaking</MenuItem>
                <MenuItem onClick={() => handleCategorySelect('listening')}>Listening</MenuItem>
                <MenuItem onClick={() => handleCategorySelect('writing')}>Writing</MenuItem>
            </Menu>
            <Modal
                open={deleteSectionModal.open}
                onClose={cancelDeleteSection}
            >
                <ModalContent>
                    <ModalTitle>Delete Section</ModalTitle>
                    <ModalText>
                        Are you sure you want to delete this section? All questions in this section will be removed. This action cannot be undone.
                    </ModalText>
                    <ModalButtonRow>
                        <Button
                            variant="outlined"
                            onClick={cancelDeleteSection}
                            style={{ minWidth: 100 }}
                        >
                            Cancel
                        </Button>
                        <Button
                            variant="contained"
                            color="error"
                            onClick={confirmDeleteSection}
                            style={{ minWidth: 100 }}
                        >
                            Delete
                        </Button>
                    </ModalButtonRow>
                </ModalContent>
            </Modal>
            <Wrapper>
                <Row className="editQuizUpr">
                    <Col xs={24} sm={24} md={24} style={{ padding: "10px 12px 12px 12px" }}>
                        <Row justify="start" style={{ alignItems: "flex-end" }} gutter={[15, 15]}>
                            <Col span={5}>
                                <Acent inputRef={dispNameRef} setValue={setdisplayName} style={{ marginBottom: 5, display: "flex", justifyContent: "flex-end" }} />
                                <TextField
                                    id="Exam_title"
                                    name="Exam_title"
                                    label="Exam Title"
                                    InputLabelProps={{ shrink: true, required: true }}
                                    type="text"
                                    required
                                    inputRef={dispNameRef}
                                    variant="outlined"
                                    onChange={e => {
                                        setdisplayName(e.target.value)
                                    }}
                                    value={displayName}
                                />
                            </Col>
                            <Col span={3}>
                                <TextField
                                    id="duration"
                                    variant="outlined"
                                    label="Duration in minutes"
                                    onChange={(e) => {
                                        if(typeof e.target.value=="string"){
                                            setduration(parseInt(e.target.value))
                                        }else{
                                            setduration(e.target.value)
                                        }
                                    }}
                                    value={duration}
                                    type="number"
                                    InputProps={{
                                        inputProps: {
                                            min: 0,
                                            max: 100
                                        },
                                        shrink: true,
                                    }}
                                />
                            </Col>
                            <Col span={4}>
                                <div style={{ display: 'flex', flexDirection: 'row', gap: 10, alignItems: 'center' }}>
                                    {/* <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={loadDraft}
                                        style={{ 
                                            height: 42,
                                            fontWeight: 600,
                                            textTransform: 'none',
                                            borderRadius: 6,
                                            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                                            flex: '0 0 auto'
                                        }}
                                    >
                                       Apply Draft Data
                                    </Button> */}
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        startIcon={<Add />}
                                        onClick={onAddSections}
                                        style={{ 
                                            height: 42,
                                            fontWeight: 600,
                                            textTransform: 'none',
                                            borderRadius: 6,
                                            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                                            flex: '0 0 auto'
                                        }}
                                    >
                                       Add Section
                                    </Button>
                                    <Button
                                        onClick={()=>{
                                        setConfigDomainModal({ open: true, domain: 'reading' })
                                        }}
                                        disabled={questions.length == 0 || (!displayName || displayName.length == 0) || loading}
                                        variant="contained"
                                        style={{ 
                                            height: 42,
                                            fontWeight: 600,
                                            textTransform: 'none',
                                            borderRadius: 6,
                                            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                                            flex: '0 0 auto'
                                        }}
                                        color="primary">
                                          <SettingsOutlined fontSize="small" /> Config Domain
                                    </Button>
                                    <Button
                                        onClick={onSubmit}
                                        disabled={questions.length == 0 || (!displayName || displayName.length == 0) || loading || errors.length > 0}
                                        variant="contained"
                                        style={{ 
                                            height: 42,
                                            fontWeight: 600,
                                            textTransform: 'none',
                                            borderRadius: 6,
                                            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                                            flex: '0 0 auto'
                                        }}
                                        color="primary">
                                        {loading ? <Loading white size={15} /> : null} {isEditing ? "Update Exam" : "Create Exam"}
                                    </Button>
                                </div>
                            </Col>
                        </Row>
                        <Col style={{ maxHeight: 70, overflow: "auto", display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-start', widht: "fit-content", marginLeft: "auto" }}>
                                {errors.length > 0 ? (
                                    <div style={{ textAlign: 'right', maxWidth: '100%' }}>
                                        {errors.map((v, index) => (
                                            <Typography 
                                                key={index} 
                                                variant="subtitle2" 
                                                style={{ 
                                                    whiteSpace: "pre-wrap", 
                                                    textAlign: 'right',
                                                    marginBottom: 4,
                                                    fontSize: "15px"
                                                }} 
                                                color="error"
                                            >
                                                * {v}
                                            </Typography>
                                        ))}
                                    </div>
                                ) : null}
                            </Col>
                        {questions.length > 0 ? (
                            <>
                                <Row justify="start" style={{ marginTop: 24, marginBottom: 16 }}>
                                    <Col span={24}>
                                        <Tabs
                                            value={selectedTab}
                                            onChange={(e, newValue) => setSelectedTab(newValue)}
                                            indicatorColor="primary"
                                            textColor="primary"
                                            style={{ borderBottom: `1px solid ${COLOR.black800}` }}
                                            sx={{
                                                '& .MuiTab-root': {
                                                    color: COLOR.black600,
                                                    '&.Mui-selected': {
                                                        color: '#03999e',
                                                        fontWeight: 600
                                                    }
                                                },
                                                '& .MuiTabs-indicator': {
                                                    backgroundColor: '#03999e',
                                                    transition: 'all 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
                                                    height: 3
                                                }
                                            }}
                                        >
                                            <Tab 
                                                label={`All (${questions.length})`} 
                                                value="all" 
                                                style={{ textTransform: 'none', fontWeight: 500, fontSize: 14 }} 
                                            />
                                            <Tab 
                                                label={`Reading (${questions.filter(s => s.category_type === 'reading').length})`} 
                                                value="reading" 
                                                style={{ textTransform: 'none', fontWeight: 500, fontSize: 14 }} 
                                            />
                                            <Tab 
                                                label={`Speaking (${questions.filter(s => s.category_type === 'speaking').length})`} 
                                                value="speaking" 
                                                style={{ textTransform: 'none', fontWeight: 500, fontSize: 14 }} 
                                            />
                                            <Tab 
                                                label={`Listening (${questions.filter(s => s.category_type === 'listening').length})`} 
                                                value="listening" 
                                                style={{ textTransform: 'none', fontWeight: 500, fontSize: 14 }} 
                                            />
                                            <Tab 
                                                label={`Writing (${questions.filter(s => s.category_type === 'writing').length})`} 
                                                value="writing" 
                                                style={{ textTransform: 'none', fontWeight: 500, fontSize: 14 }} 
                                            />
                                        </Tabs>
                                    </Col>
                                </Row>
                                {
                                        sectionWiseData.length > 0 && (
                                            <>
                                            <Row className="section-tabs-row">
                                                <Col className="section-tabs-col">
                                                  <Tabs
                                                  value={sectionSelectedTab}
                                                  onChange={(e, newValue) => setSectionSelectedTab(newValue)}
                                                  indicatorColor="primary"
                                                  textColor="primary"
                                                  style={{ borderBottom: `1px solid ${COLOR.black800}` }}
                                                  sx={{
                                                      '& .MuiTab-root': {
                                                          color: COLOR.black600,
                                                          '&.Mui-selected': {
                                                              color: '#03999e',
                                                              fontWeight: 600
                                                          }
                                                      },
                                                      '& .MuiTabs-indicator': {
                                                          backgroundColor: '#03999e',
                                                          transition: 'all 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
                                                          height: 3
                                                      }
                                                  }}>
                                                    {
                                                        sectionWiseData.map((section, index) => (
                                                            <Tab 
                                                                key={section._originalIndex} 
                                                                value={section._originalIndex} 
                                                                label={`Section ${section._originalIndex + 1}`} 
                                                                style={{ textTransform: 'none', fontWeight: 500, fontSize: 14 }}  
                                                            />
                                                        ))
                                                    }
                                                  </Tabs>
                                                
                                                </Col>
                                            </Row>
                                            </>
                                        )
                                    }
                                <SectionWrapper ref={ref => innerRef.current["section_container"] = ref}>       
                            {(() => {
                                if (sectionWiseData.length === 0) {
                                    return (
                                        <FilteredEmptyState>
                                            No {selectedTab === 'all' ? '' : selectedTab} sections added yet
                                        </FilteredEmptyState>
                                    );
                                }
                                
                                return map(sectionWiseData, (sections, filteredIndex) => {
                                const section_index = sections._originalIndex;
                                if(section_index !== sectionSelectedTab) return null;
                                return (<InnerWrapper key={section_index}>
                                    <Row gutter={[16, 0]} style={{ alignItems: 'stretch', flexWrap: 'nowrap', width: '100%', flex: 1, minHeight: 0, margin: 0 }}>
                                        <Col flex="0 0 40%" style={{ minWidth: 0, minHeight: 0, height: '100%', display: 'flex' }}>
                                    <InnerSectionScroll style={{ width: '100%' }}>
                                    <Card style={{ padding: 16, borderRadius: 8, boxShadow: '0 2px 8px rgba(0,0,0,0.08)' }} bodyStyle={{ padding: 0 }}>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
                                            <SectionLabel sectionIndex={section_index} numberStyle={{ height: 28, width: 28 }} titleStyle={{ marginTop: -8, marginBottom: 0 }} />
                                            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                                <Typography variant="caption" style={{ color: COLOR.black600, fontWeight: 500 }}>
                                                    {sections.questions?.length || 0} {sections.questions?.length === 1 ? 'Question' : 'Questions'}
                                                </Typography>
                                                <IconButton 
                                                    onClick={() => { onDeleteSection(section_index) }} 
                                                    style={{ 
                                                        padding: 6,
                                                        color: COLOR.radish100,
                                                        '&:hover': { backgroundColor: 'rgba(244, 67, 54, 0.1)' }
                                                    }}
                                                    size="small"
                                                >
                                                    <Delete fontSize="small" />
                                                </IconButton>
                                            </div>
                                        </div>
                                        <Row justify="start" style={{ marginBottom: 16, alignItems: "center"}} gutter={[12, 12]}>
                                            <Col span={24}>
                                                <div style={{ display: "flex", flexDirection: "row", gap: 8, alignItems: "center", flexWrap: "nowrap" }}>
                                                    <div style={{ display: 'flex', flexDirection: 'column', flexShrink: 0, minWidth: 140 }}>
                                                        <Typography variant="caption" style={{ color: 'rgba(0,0,0,0.6)', marginBottom: 4 }}>
                                                            Total Max Points
                                                        </Typography>
                                                        <Typography variant="body2" style={{ fontWeight: 500 }}>
                                                            {sections.questions?.reduce((sum, q) => {
                                                                const maxPoint = parseFloat(q.max_point) || 0;
                                                                return sum + maxPoint;
                                                            }, 0) || sections?.max_point || '0'}
                                                        </Typography>
                                                    </div>
                                                    <div style={{ display: "flex", flexDirection: "row", gap: 8, alignItems: "center", flexShrink: 1, flexWrap: "wrap" }}>
                                                        <AddAudioTOsection audio_url={sections.audio} onChange={v => { trenacriptAudio(v); addSectionData("audio", v, section_index) }} />
                                                        <AddvideoToSections video_url={sections.video} onChange={v => { trenacriptAudio(v); addSectionData("video", v, section_index) }} />
                                                        <AddImageToSections image_url={sections.image} onChange={v => addSectionData("image", v, section_index)} />
                                                    </div>
                                                </div>
                                            </Col>
                                        </Row>
                                        <div style={{ marginBottom: 16 }}>
                                            <div style={{ marginBottom: 12 }}>
                                                <TextEditor
                                                    value={sections.instruction ?? ''}
                                                    handleChange={v => addSectionData("instruction", v, section_index)}
                                                    autoFocus={false}
                                                    placeholder="Section instruction..."
                                                />
                                            </div>
                                            <FormControl variant="outlined" fullWidth size="small">
                                                <InputLabel style={{ backgroundColor: 'white', paddingRight: 5 }} id="category_type">Skill Type</InputLabel>
                                                <Select
                                                    labelId="category_type"
                                                    id="category_type"
                                                    value={sections.category_type || ''}
                                                    onChange={(e) => {
                                                        addSectionData("category_type", e.target.value, section_index)
                                                    }}
                                                    label="Category Type"
                                                >
                                                    <MenuItem value="reading">Reading</MenuItem>
                                                    <MenuItem value="speaking">Speaking</MenuItem>
                                                    <MenuItem value="listening">Listening</MenuItem>
                                                    <MenuItem value="writing">Writing</MenuItem>
                                                </Select>
                                            </FormControl>
                                        </div>
                                        <Row justify="space-between" style={{ marginBottom: 10, alignItems: "center" }} gutter={[15, 15]}>
                                            <Col flex="none">
                                                <ModalMenu
                                                    type={"selectRubricModal"}
                                                    addedRubric={getRubricData(sections.rubric_id)}
                                                    editable={{ editing: false }}
                                                    setAddedRubric={(val) => {
                                                        editRubricsForSection(val, section_index)
                                                    }}
                                                    is_placement={true}
                                                    resetConfig={() => {
                                                        editRubricsForSection({}, section_index)
                                                    }}
                                                />
                                            </Col>
                                            <Col flex="none" style={{ marginLeft: 'auto' }}>
                                                <Button
                                                    className='adoVdoAddBtn'
                                                    variant="contained"
                                                    color="primary"
                                                    startIcon={<Add />}
                                                    size="small"
                                                    style={{
                                                        height: 36,
                                                        fontWeight: 500,
                                                        textTransform: 'none',
                                                        borderRadius: 6
                                                    }}
                                                    onClick={() => onAddQuestion(section_index)}
                                                >
                                                    Add Question
                                                </Button>
                                            </Col>
                                        </Row>
                                    </Card>
                                    </InnerSectionScroll>
                                        </Col>
                                        <Col flex="0 0 60%" style={{ minWidth: 0, minHeight: 0, height: '100%' }}>
                                    <InnerQuestionWrapper ref={ref => innerRef.current[section_index] = ref}>
                                        {map(sections.questions, (question, index) => (<RelativeContainer key={section_index + "section_" + index}>
                                            <Accordion
                                                key={question.id}
                                                expanded={!questionAccordionCollapsed.has(`${section_index}-${index}`)}
                                                disableGutters
                                                square
                                                sx={{ boxShadow: 'none', '&:before': { display: 'none' }, borderLeft: `3px solid ${COLOR.green100}`, borderTop: `1px solid ${COLOR.black800}`, borderRight: `1px solid ${COLOR.black800}`, borderBottom: `1px solid ${COLOR.black800}`, borderRadius: '8px', overflow: 'hidden', '&.Mui-expanded': { margin: 0 } }}
                                            >
                                                <AccordionSummary
                                                    expandIcon={null}
                                                    sx={{
                                                        minHeight: 52,
                                                        backgroundColor: '#fafafa',
                                                        pointerEvents: 'none',
                                                        '& .MuiAccordionSummary-content': {
                                                            margin: '12px 0',
                                                            alignItems: 'center',
                                                            display: 'flex',
                                                            width: '100%',
                                                            flexDirection: 'row',
                                                            justifyContent: 'space-between',
                                                            pointerEvents: 'auto'
                                                        },
                                                        '&.Mui-expanded': { minHeight: 52 },
                                                        '&.Mui-expanded .accordion-expand-icon': { transform: 'rotate(180deg)' }
                                                    }}
                                                >
                                                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                                        <Detail index={index}>Question {index + 1} of {sections.questions?.length || 0}</Detail>
                                                        <IconButton
                                                            onClick={(e) => { e.stopPropagation(); e.preventDefault(); toggleQuestionAccordion(section_index, index); }}
                                                            size="small"
                                                            sx={{ pointerEvents: 'auto', color: 'rgba(0,0,0,0.54)' }}
                                                        >
                                                            <ExpandMore sx={{ transition: 'transform 0.2s' }} className="accordion-expand-icon" />
                                                        </IconButton>
                                                    </div>
                                                    <IconButton
                                                        onClick={(e) => { e.stopPropagation(); e.preventDefault(); onDeleteQuestion(section_index, index); }}
                                                        style={{ padding: 6, color: COLOR.radish100 }}
                                                        size="small"
                                                        sx={{ pointerEvents: 'auto' }}
                                                    >
                                                        <Delete fontSize="small" />
                                                    </IconButton>
                                                </AccordionSummary>
                                                <AccordionDetails sx={{ pt: 0 }}>
                                            <QuestionContainer>
                                                <div style={{ marginBottom: 16, display: 'flex', flexDirection: 'row', gap: 12, alignItems: 'flex-start' }}>
                                                    <FormControl variant="outlined" size="small" style={{ flex: '0 0 75%', width: '75%' }}>
                                                        <InputLabel style={{ backgroundColor: 'white', paddingRight: 5 }} id="type">Question Type</InputLabel>
                                                        <Select
                                                            labelId="type"
                                                            id="type"
                                                            value={question.type}
                                                            required
                                                            onChange={(v) => {
                                                                onChangeQuestionType(v.target.value, index, section_index)
                                                            }}
                                                            label="Question Type"
                                                        >
                                                            {QUESTION_TYPE?.map(v => (<MenuItem key={v.value} value={v.value}>{v.type}</MenuItem>))}
                                                        </Select>
                                                    </FormControl>
                                                    <TextField
                                                        id="question_max_point"
                                                        name="question_max_point"
                                                        label="Max Points"
                                                        InputLabelProps={{ shrink: true, required: true }}
                                                        type="number"
                                                        variant="outlined"
                                                        size="small"
                                                        style={{ flex: '0 0 25%', width: '25%' }}
                                                        required
                                                        disabled={!!sections.rubric_id}
                                                        onChange={e => {
                                                            const value = e.target.value === '' ? null : parseFloat(e.target.value);
                                                            onChangeQuestionData(value, "max_point", index, section_index)
                                                        }}
                                                        value={question.max_point || ''}
                                                        InputProps={{
                                                            inputProps: {
                                                                min: 0,
                                                                max: 100,
                                                                step: 0.1,
                                                                onWheel: (e) => e.target.blur()
                                                            }
                                                        }}
                                                    />
                                                </div>
                                                {question.type !== QUESTION_TYPES.MULTIPLE_CHOICE && question.type !== QUESTION_TYPES.TRUE_FALSE && question.type !== QUESTION_TYPES.AUDIO_MULTICHOICE ? (
                                                        <div style={{ marginBottom: 16, flex: '0 0 100%', width: '100%' }}>
                                                            <TextField
                                                                InputLabelProps={{ shrink: true, required: false }}
                                                                label="Grade prompt"
                                                                placeholder="Prompt for grading this question"
                                                                multiline
                                                                minRows={2}
                                                                required={false}
                                                                fullWidth
                                                                variant="outlined"
                                                                size="small"
                                                                value={question.grade_prompt ?? ''}
                                                                onChange={e => onChangeQuestionData(e.target.value, "grade_prompt", index, section_index)}
                                                            />
                                                        </div>
                                                    ) : null}
                                                {(question.type !== QUESTION_TYPES.AUDIO_MULTICHOICE && question.type !== QUESTION_TYPES.AUDIO_WRITTEN_RESPONSE) ? <div style={{ marginBottom: 16 }}>
                                                    <Acent inputRef={questionRefs.current[section_index + "input1_" + index]} setValue={v => onChangeQuestionData(v, "question", index, section_index)} style={{ marginBottom: 8, display: "flex", justifyContent: "flex-end" }} />
                                                    <TextField
                                                        id="question"
                                                        name="question"
                                                        label="Question"
                                                        InputLabelProps={{ shrink: true, required: true }}
                                                        type="text"
                                                        fullWidth
                                                        inputRef={ref => questionRefs.current[section_index + "input1_" + index] = ref}
                                                        required
                                                        variant="outlined"
                                                        size="small"
                                                        onChange={e => {
                                                            onChangeQuestionData(e.target.value, "question", index, section_index)
                                                        }}
                                                        value={question.question}
                                                    />
                                                </div>:null}
                                                <div style={{ marginBottom: 16 }}>
                                                    <Acent inputRef={ questionRefs.current[section_index + "input1_instruction" + index]} setValue={v =>    onChangeQuestionData(v, "instruction", index, section_index)} style={{ marginBottom: 8, display: "flex", justifyContent: "flex-end" }} />
                                                    <TextField
                                                        id="section_instruction"
                                                        name="section_instruction"
                                                        label="Instruction"
                                                        InputLabelProps={{ shrink: true }}
                                                        type="text"
                                                        fullWidth
                                                        inputRef={ref => questionRefs.current[section_index + "input1_instruction" + index] = ref}
                                                        variant="outlined"
                                                        size="small"
                                                        onChange={e => {
                                                            onChangeQuestionData(e.target.value, "instruction", index, section_index)
                                                        }}
                                                        value={question.instruction}
                                                    />
                                                </div>
                                                <Content>
                                                    {question.type === QUESTION_TYPES.ESSAY && (
                                                        <>
                                                         <div style={{ marginBottom: 16 }}>
                                                                <PictureAssignment
                                                                    disabled={false}
                                                                    source={question.image}
                                                                    handlePicture={(v) => onChangeQuestionData(v, "image", index, section_index)}
                                                                />
                                                            </div>
                                                            <Row gutter={[0, 24]} style={{ marginBottom: 16 }}>
                                                                <Col span={24}>
                                                                    <TextEditor
                                                                        handleChange={() => { }}
                                                                        value={''}
                                                                        autoFocus={false}
                                                                        disabled={true}
                                                                    />
                                                                </Col>
                                                            </Row>
                                                        </>
                                                    )}
                                                    {question.type === QUESTION_TYPES.MULTIPLE_CHOICE && (
                                                        <>
                                                            <div style={{ marginBottom: 16 }}>
                                                                <PictureAssignment
                                                                    disabled={false}
                                                                    source={question.image}
                                                                    handlePicture={(v) => onChangeQuestionData(v, "image", index, section_index)}
                                                                />
                                                            </div>
                                                            <FormControl variant="outlined" className={classes.formControl} style={{ marginBottom: 16 }}>
                                                                <InputLabel id="type" style={{ backgroundColor: "#fff" }}>Number of options</InputLabel>
                                                                <Select
                                                                    labelId="level"
                                                                    id="level"
                                                                    required={false}
                                                                    value={get(question, "options.length", 4)}
                                                                    onChange={(v) => {
                                                                        onChangeOptionsLength(index, parseInt(v.target.value), section_index)
                                                                    }}
                                                                    label="Type"
                                                                >
                                                                    <MenuItem value={2}>2</MenuItem>
                                                                    <MenuItem value={3}>3</MenuItem>
                                                                    <MenuItem value={4}>4</MenuItem>
                                                                    <MenuItem value={5}>5</MenuItem>
                                                                </Select>
                                                            </FormControl>
                                                            {map(get(question, "options", ['', '', '', '']), (option, optId) => (
                                                                <Row key={optId} style={{ marginBottom: '8px' }}>
                                                                    <RadioGroup style={{ display: "flex", flexDirection: "row", width: "100%" }} aria-label="options" name={`options-${index}`} value={`${question.answer}`} onChange={(e) => { onChangeQuestionData(parseInt(e.target.value), "answer", index, section_index) }}>
                                                                        <Row style={{ width: "100%" }}>
                                                                            <RadioColumn span={2}>
                                                                                <FormControlLabel value={`${optId}`} checked={optId == question.answer} control={<Radio />} />
                                                                            </RadioColumn>
                                                                            <Col span={22}>
                                                                                <Acent inputRef={optionRefs.current[`${section_index}-${index}-${optId}`]} setValue={v => onchangeOption(index, optId, v, section_index)} style={{ marginBottom: 5, display: "flex", justifyContent: "flex-end" }} />
                                                                                <TextField
                                                                                    id={`question${index + optId}`}
                                                                                    name="options"
                                                                                    label={`option ${LABEL[optId]}`}
                                                                                    InputLabelProps={{ shrink: true, required: true }}
                                                                                    type="text"
                                                                                    required
                                                                                    inputRef={ref => optionRefs.current[`${section_index}-${index}-${optId}`] = ref}
                                                                                    variant="outlined"
                                                                                    onChange={e => {
                                                                                        onchangeOption(index, optId, e.target.value, section_index)
                                                                                    }}
                                                                                    value={option}
                                                                                />

                                                                            </Col>

                                                                        </Row>


                                                                    </RadioGroup>

                                                                </Row>
                                                            ))}
                                                        </>
                                                    )}
                                                    {question.type === QUESTION_TYPES.AUDIO && (
                                                        <>
                                                            <Question style={{ marginBottom: 16 }}>
                                                                <FormControl variant="outlined" className={classes.formControl}>
                                                                    <InputLabel id="durations">Time</InputLabel>
                                                                    <Select
                                                                        labelId="durations"
                                                                        id="durations"
                                                                        value={question.duration || '60'}
                                                                        required
                                                                        onChange={(v) => {
                                                                            onChangeQuestionData(v.target.value, "duration", index, section_index)
                                                                        }}
                                                                        label="Type"
                                                                    >
                                                                        {DURATIONS.map(v => (<MenuItem value={v.value}>{v.label}</MenuItem>))}
                                                                    </Select>
                                                                </FormControl>
                                                            </Question>
                                                            <Question style={{ marginBottom: 16 }}>
                                                                <AudioRecorder
                                                                    handleAudio={(v) => {
                                                                        onChangeQuestionData(v, "audio", index, section_index)
                                                                        trenacriptAudio(v)
                                                                    }}
                                                                    index={index}
                                                                    currentSubmission={{}}
                                                                    refresh={() => { }}
                                                                    source={question.audio}
                                                                    hasSaveButton
                                                                    message={`Record a question`}
                                                                />
                                                            </Question>
                                                            <Question style={{ marginBottom: 16, textAlign: "center" }}>
                                                                OR
                                                            </Question>
                                                            <AudioPicker
                                                                message={"Upload a audio file for question..."}
                                                                onChange={v => {
                                                                    trenacriptAudio(v)
                                                                    onChangeQuestionData(v, "audio", index, section_index)
                                                                }}
                                                            />
                                                            <AudioRecorder
                                                                maxTime={question.duration || 20}
                                                                handleAudio={() => { }}
                                                                index={index}
                                                                currentSubmission={{}}
                                                                refresh={() => { }}
                                                                isPreview
                                                            />
                                                        </>
                                                    )}
                                                    {question.type === QUESTION_TYPES.AUDIO_WRITTEN_RESPONSE && (
                                                        <>
                                                            <Question style={{ marginBottom: 16 }}>
                                                                <AudioRecorder
                                                                    handleAudio={(v) => {
                                                                        onChangeQuestionData(v, "audio", index, section_index)
                                                                        trenacriptAudio(v)
                                                                    }}
                                                                    index={index}
                                                                    currentSubmission={{}}
                                                                    refresh={() => { }}
                                                                    source={question.audio}
                                                                    hasSaveButton
                                                                    message={`Record a question`}
                                                                />
                                                            </Question>
                                                            <Question style={{ marginBottom: 16, textAlign: "center" }}>
                                                                OR
                                                            </Question>
                                                            <AudioPicker
                                                                message={"Upload a audio file for question..."}
                                                                onChange={v => {
                                                                    trenacriptAudio(v)
                                                                    onChangeQuestionData(v, "audio", index, section_index)
                                                                }}
                                                            />
                                                            <TextEditor
                                                                handleChange={() => { }}
                                                                value={''}
                                                                autoFocus={false}
                                                                disabled={true}
                                                            />
                                                        </>
                                                    )}
                                                    {question.type === QUESTION_TYPES.AUDIO_MULTICHOICE && (
                                                        <>
                                                            <Question style={{ marginBottom: 16 }}>
                                                                <AudioRecorder
                                                                    handleAudio={(v) => {
                                                                        onChangeQuestionData(v, "audio", index, section_index)
                                                                        trenacriptAudio(v)
                                                                    }}
                                                                    index={index}
                                                                    currentSubmission={{}}
                                                                    refresh={() => { }}
                                                                    source={question.audio}
                                                                    hasSaveButton
                                                                    message={`Record a question`}
                                                                />
                                                            </Question>
                                                            <Question style={{ marginBottom: 16, textAlign: "center" }}>
                                                                OR
                                                            </Question>
                                                            <AudioPicker
                                                                message={"Upload a audio file for question..."}
                                                                onChange={v => {
                                                                    trenacriptAudio(v)
                                                                    onChangeQuestionData(v, "audio", index, section_index)
                                                                }}
                                                            />
                                                            <FormControl variant="outlined" className={classes.formControl} style={{ marginBottom: 16 }}>
                                                                <InputLabel id="type" style={{ backgroundColor: "#fff" }}>Number of options</InputLabel>
                                                                <Select
                                                                    labelId="level"
                                                                    id="level"
                                                                    required={false}
                                                                    value={get(question, "options.length", 4)}
                                                                    onChange={(v) => {
                                                                        onChangeOptionsLength(index, parseInt(v.target.value), section_index)
                                                                    }}
                                                                    label="Type"
                                                                >
                                                                    <MenuItem value={2}>2</MenuItem>
                                                                    <MenuItem value={3}>3</MenuItem>
                                                                    <MenuItem value={4}>4</MenuItem>
                                                                    <MenuItem value={5}>5</MenuItem>
                                                                </Select>
                                                            </FormControl>
                                                            {map(get(question, "options", ['', '', '', '']), (option, optId) => (
                                                                <Row key={optId} style={{ marginBottom: '8px' }}>
                                                                    <RadioGroup style={{ display: "flex", flexDirection: "row", width: "100%" }} aria-label="options" name={`options-${index}`} value={`${question.answer}`} onChange={(e) => { onChangeQuestionData(parseInt(e.target.value), "answer", index, section_index) }}>
                                                                        <Row style={{ width: "100%" }}>
                                                                            <RadioColumn span={2}>
                                                                                <FormControlLabel value={`${optId}`} checked={optId == question.answer} control={<Radio />} />
                                                                            </RadioColumn>
                                                                            <Col span={22}>
                                                                                <Acent inputRef={optionRefs.current[`${section_index}-${index}-${optId}`]} setValue={v => onchangeOption(index, optId, v, section_index)} style={{ marginBottom: 5, display: "flex", justifyContent: "flex-end" }} />
                                                                                <TextField
                                                                                    id={`question${index + optId}`}
                                                                                    name="options"
                                                                                    label={`option ${LABEL[optId]}`}
                                                                                    InputLabelProps={{ shrink: true, required: true }}
                                                                                    type="text"
                                                                                    required
                                                                                    inputRef={ref => optionRefs.current[`${section_index}-${index}-${optId}`] = ref}
                                                                                    variant="outlined"
                                                                                    onChange={e => {
                                                                                        onchangeOption(index, optId, e.target.value, section_index)
                                                                                    }}
                                                                                    value={option}
                                                                                />

                                                                            </Col>
                                                                        </Row>
                                                                    </RadioGroup>
                                                                </Row>
                                                            ))}
                                                        </>
                                                    )}

                                                    {question.type === QUESTION_TYPES.TRUE_FALSE && (
                                                        <>
                                                            {map(get(question, "options", ['Cierto', 'Falso']), (option, optId) => (
                                                                <Row key={optId} style={{ marginBottom: '8px' }}>
                                                                    <RadioGroup style={{ display: "flex", flexDirection: "row", width: "100%" }} aria-label="options" name={`options-${index}`} value={`${question.answer}`} onChange={(e) => { onChangeQuestionData(parseInt(e.target.value), "answer", index, section_index) }}>
                                                                        <Row style={{ width: "100%" }}>
                                                                            <RadioColumn span={2}>
                                                                                <FormControlLabel value={`${optId}`} checked={optId == question.answer} control={<Radio />} />
                                                                            </RadioColumn>
                                                                            <Col span={22}>
                                                                                <Acent inputRef={optionRefs.current[`${section_index}-${index}-${optId}`]} setValue={v => onchangeOption(index, optId, v, section_index)} style={{ marginBottom: 5, display: "flex", justifyContent: "flex-end" }} />
                                                                                <TextField
                                                                                    id={`question${index + optId}`}
                                                                                    name="options"
                                                                                    label={`option ${LABEL[optId]}`}
                                                                                    InputLabelProps={{ shrink: true, required: true }}
                                                                                    type="text"
                                                                                    required
                                                                                    inputRef={ref => optionRefs.current[`${section_index}-${index}-${optId}`] = ref}
                                                                                    variant="outlined"
                                                                                    onChange={e => {
                                                                                        onchangeOption(index, optId, e.target.value, section_index)
                                                                                    }}
                                                                                    value={option}
                                                                                />

                                                                            </Col>

                                                                        </Row>


                                                                    </RadioGroup>

                                                                </Row>
                                                            ))}
                                                        </>
                                                    )}
                                                </Content>
                                            </QuestionContainer>
                                                </AccordionDetails>
                                            </Accordion>
                                        </RelativeContainer>))}
                                    </InnerQuestionWrapper>
                                        </Col>
                                    </Row>

                                </InnerWrapper>)

                            });
                            })()}
                        </SectionWrapper>
                            </>
                        ) : (
                            <EmptyStatePlaceholder>
                                <EmptyStateTitle>No Sections Added</EmptyStateTitle>
                                <EmptyStateText>
                                    Start building your exam by adding sections. Each section can contain multiple questions of different types like multiple choice, essay, audio, and more.
                                </EmptyStateText>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    startIcon={<Add />}
                                    onClick={onAddSections}
                                    style={{ 
                                        height: 44,
                                        fontWeight: 600,
                                        textTransform: 'none',
                                        borderRadius: 8,
                                        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                                        padding: '0 24px'
                                    }}
                                >
                                    Add Your First Section
                                </Button>
                            </EmptyStatePlaceholder>
                        )}
                    </Col>
                </Row>
            </Wrapper>
            <Modal
                open={configDomainModal.open}
                onClose={() => setConfigDomainModal({ open: false, domain: null })}
                aria-labelledby="config-domain-modal"
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    p: { xs: 1, sm: 2 },
                    '& .MuiBackdrop-root': { backgroundColor: 'rgba(0,0,0,0.5)' },
                }}
            >
                <ConfigDomainCard>
                    <ConfigDomainHeader>
                        <Typography id="config-domain-modal" variant="h6" sx={{ fontWeight: 600, marginBottom: 0.5, letterSpacing: '-0.01em', fontSize: { xs: '1rem', sm: '1.25rem' } }}>
                            Config Domain
                        </Typography>
                        <ConfigDomainTablist role="tablist">
                            {CONFIG_DOMAIN_CATEGORIES.map(cat => {
                                const isActive = (configDomainModal.domain ?? 'reading') === cat.key;
                                const sectionsUsingCategory = questions.filter(s => getCategoryKeysForMaxPoints(cat.key).includes((s.category_type || '').toLowerCase()));
                                const hasDomainType = sectionsUsingCategory.length > 0;
                                const hasEmptyRange = DOMAIN_LEVELS.some(dom => {
                                    const val = domainConfig[cat.key]?.[dom.key];
                                    return String(val?.from ?? '').trim() === '' || String(val?.to ?? '').trim() === '';
                                });
                                const categoryMaxPoint = sectionsUsingCategory.reduce((sum, s) => sum + (parseFloat(s.max_point) || 0), 0);
                                const advanceHighTo = Number.parseFloat(String(domainConfig?.[cat.key]?.advance_high?.to ?? '').trim());
                                const hasAdvanceHighMismatch = categoryMaxPoint > 0 && (Number.isNaN(advanceHighTo) || Math.abs(advanceHighTo - categoryMaxPoint) > 0.01);
                                const hasMissing = hasEmptyRange || hasAdvanceHighMismatch;
                                return (
                                    <Tooltip key={cat.key} title={getCategoryTooltip(cat.key) || cat.label} placement="top">
                                        <ConfigDomainTabBtn
                                            type="button"
                                            role="tab"
                                            aria-selected={isActive}
                                            $active={isActive}
                                            $hasMissing={hasMissing}
                                            onClick={() => setConfigDomainModal(prev => ({ ...prev, domain: cat.key }))}
                                        >
                                            {cat.label}{!hasDomainType ? ' (Not required)' : ''}
                                        </ConfigDomainTabBtn>
                                    </Tooltip>
                                );
                            })}
                        </ConfigDomainTablist>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', padding: '10px 0', flexWrap: 'wrap', gap: 8 }}>
                            <Typography variant="body2" sx={{ fontWeight: 500 }}>
                                Max point:- {questions
                                    .filter(s => getCategoryKeysForMaxPoints(configDomainModal.domain ?? 'reading').includes((s.category_type || '').toLowerCase()))
                                    .reduce((sum, s) => sum + (parseFloat(s.max_point) || 0), 0)}
                            </Typography>
                            <Button
                                variant="outlined"
                                size="small"
                                onClick={() => {
                                    const currentDomain = configDomainModal.domain ?? 'reading';
                                    const maxPoint = questions
                                        .filter(s => getCategoryKeysForMaxPoints(currentDomain).includes((s.category_type || '').toLowerCase()))
                                        .reduce((sum, s) => sum + (parseFloat(s.max_point) || 0), 0);
                                    createRangeBasedonMaxPoint(maxPoint, currentDomain);
                                }}
                                sx={{ textTransform: 'none', fontWeight: 600 }}
                            >
                                Calculate Range
                            </Button>
                        </div>
                    </ConfigDomainHeader>
                    <ConfigDomainBody>
                        {CONFIG_DOMAIN_CATEGORIES.map(cat => (
                            <div
                                key={cat.key}
                                role="tabpanel"
                                hidden={(configDomainModal.domain ?? 'reading') !== cat.key}
                            >
                                {(configDomainModal.domain ?? 'reading') === cat.key && (
                                    <>
                                        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                                            {DOMAIN_LEVELS.map(dom => (
                                                <ConfigDomainRow key={dom.key}>
                                                    <ConfigDomainRowLabel variant="body2">
                                                        {dom.label}
                                                    </ConfigDomainRowLabel>
                                                    <TextField
                                                        fullWidth
                                                        size="small"
                                                        placeholder="From"
                                                        type="number"
                                                        inputProps={{ min: 0, max: 100, onWheel: e => e.target.blur() }}
                                                        InputLabelProps={{ shrink: true }}
                                                        sx={{ '& .MuiOutlinedInput-root': { backgroundColor: '#fff' } }}
                                                        value={domainConfig[cat.key]?.[dom.key]?.from ?? ''}
                                                        onChange={e => {
                                                            const v = e.target.value;
                                                            const next = v === '' ? '' : (() => {
                                                                const n = Number(v);
                                                                return isNaN(n) ? v : String(Math.min(100, Math.max(0, n)));
                                                            })();
                                                            setDomainConfig(prev => ({
                                                                ...prev,
                                                                [cat.key]: {
                                                                    ...prev[cat.key],
                                                                    [dom.key]: { ...prev[cat.key]?.[dom.key], from: next },
                                                                },
                                                            }));
                                                        }}
                                                    />
                                                    <TextField
                                                        fullWidth
                                                        size="small"
                                                        placeholder="To"
                                                        type="number"
                                                        inputProps={{ min: 0, max: 100, onWheel: e => e.target.blur() }}
                                                        InputLabelProps={{ shrink: true }}
                                                        sx={{ '& .MuiOutlinedInput-root': { backgroundColor: '#fff' } }}
                                                        value={domainConfig[cat.key]?.[dom.key]?.to ?? ''}
                                                        onChange={e => {
                                                            const v = e.target.value;
                                                            const next = v === '' ? '' : (() => {
                                                                const n = Number(v);
                                                                return isNaN(n) ? v : String(Math.min(100, Math.max(0, n)));
                                                            })();
                                                            setDomainConfig(prev => ({
                                                                ...prev,
                                                                [cat.key]: {
                                                                    ...prev[cat.key],
                                                                    [dom.key]: { ...prev[cat.key]?.[dom.key], to: next },
                                                                },
                                                            }));
                                                        }}
                                                    />
                                                </ConfigDomainRow>
                                            ))}
                                        </div>
                                        <ConfigDomainActions>
                                            <Button
                                                variant="outlined"
                                                onClick={() => setConfigDomainModal({ open: false, domain: null })}
                                                sx={{ textTransform: 'none', fontWeight: 600 }}
                                            >
                                                Cancel
                                            </Button>
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                onClick={() => setConfigDomainModal({ open: false, domain: null })}
                                                sx={{ textTransform: 'none', fontWeight: 600, minWidth: 88 }}
                                            >
                                                Done
                                            </Button>
                                        </ConfigDomainActions>
                                    </>
                                )}
                            </div>
                        ))}
                    </ConfigDomainBody>
                </ConfigDomainCard>
            </Modal>
        </SentryWrap>
    );
};



export default React.memo(PlacementExamForm);